import Box from '@mui/material/Box';
import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Button, TextField, Grid, Typography } from '@mui/material';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const CaseUpdateForm = (props) => {
  const [case_, setCase] = useState({
    id: props.case ? props.case.id : '',
    status: props.case ? props.case.status : 'active',
    name: props.case ? props.case.name : '',
    external_uid: props.case ? props.case.external_uid: '',
  });

  const [changed, setChanged] = useState(false)
  const [pendingDelete, setPendingDelete] = useState(false)

  const [errorMsg, setErrorMsg] = useState('');
  const { name, status, external_uid, id} = case_;

  const handleOnSubmit = () => {
    const values = [name];
    let errorMsg = '';

    const allFieldsFilled = values.every((field) => {
      const value = `${field}`.trim();
      return value !== '' && value !== '0';
    });

    if (allFieldsFilled) {
      const case_ = {
        id,
        name,
        status,
      };
      setChanged(false)
      props.handleOnSubmit(case_, () => props.setShowEdit(false))
    } else {
      errorMsg = 'Please fill out all the fields.';
    }
    setErrorMsg(errorMsg);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    switch (name) {
      default:
        setChanged(true)
        setCase((prevState) => ({
          ...prevState,
          [name]: value,
        }));
    }
  };
  const statuses = [
    { value: "INITIAL", label: "Initial" }, 
    { value: "LEGAL_REVIEW", label: "Legal Review" }, 
    { value: "RETAINER_SENT", label: "Retainer Sent" }, 
    { value: "RETAINER_DECLINED", label: "Retainer Declined" }, 
    { value: "NEEDS_DOCUMENTATION", label: "Needs Documentation" },
    { value: "REJECTED", label: "Rejected" },
    { value: "EXPIRED", label: "Expired" },
    { value: "DEMAND_PENDING", label: "Demand Pending" },
    { value: "DEMAND_SENT", label: "Demand Sent" },
    { value: "DEMAND_REFUNDED", label: "Demand Accepted: Refunded" },
    { value: "DEMAND_REPLACED", label: "Demand Accepted: Replaced" },
    { value: "LAWSUIT_PENDING", label: "Lawsuit Pending" },
    { value: "LAWSUIT_FILED", label: "Lawsuit Filed" },
    { value: "SETTLING", label: "Settling" },
    { value: "WON", label: "Won" },
    { value: "LOST", label: "Lost" },
    { value: "CLOSED", label: "Closed" },
    { value: "REFERED", label: "Refered" },
    ] 
  return (
    <div className="main-form">
      {errorMsg && <p className="errorMsg">{errorMsg}</p>}
       <Dialog
        open={pendingDelete}
        onClose={() => setPendingDelete(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Pemanently delete " +name + "?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            This cannot be undone. All files and data will be deleted. 
            <Typography sx={{fontWeight: 500, mt: 2}} >Please consider archiving.</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPendingDelete(false)}>Cancel</Button>
          <Button color='error' onClick={() => { setPendingDelete(false); props.handleCaseDestroy()}} autoFocus>
            Delete Forever 
          </Button>
        </DialogActions>
      </Dialog>
      <FormControl fullWidth>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Case Name"
              name="name"
              value={name}
              onChange={handleInputChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            
            <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Case Status</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              label="Case Status"
              name="status"
              value={status}
              onChange={handleInputChange}
              fullWidth
              required >
              {statuses.map((documentType)=> 
                <MenuItem value={documentType.value}>{documentType.label}</MenuItem>)}
            </Select>
            </FormControl>
            
          </Grid>
          <Grid item xs={8}>
            <Button variant="outlined" type="button" className="submit-btn" onClick={() => props.setShowEdit(false) }>
              Cancel 
            </Button>
            {changed &&
              <Button onClick={() => handleOnSubmit() } sx={{ ml: 1}} variant="contained" type="button" className="submit-btn">
                Update 
              </Button>
            }
          </Grid>
          <Grid  item xs={4}>
            <Box display='flex' justifyContent='flex-end'>
              <Button variant="outlined" color='error' type="button" className="submit-btn" onClick={() => setPendingDelete(true) }>
                Permanently Delete 
              </Button>
            </Box>
          </Grid>
        </Grid>
      </FormControl>
    </div>
  );
};

export default CaseUpdateForm;

